import React, { useMemo, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

type LandingTopNavProps = {
  t: (key: any) => string;
};

const isActive = (pathname: string, target: string) => {
  if (target === '/') return pathname === '/' || pathname === '/landing';
  return pathname === target;
};

export const LandingTopNav: React.FC<LandingTopNavProps> = ({ t }) => {
  const { pathname } = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [openFaqIndex, setOpenFaqIndex] = useState<number | null>(null);

  const faqItems = useMemo(
    () => [
      { q: 'faqQ1', a: 'faqA1' },
      { q: 'faqQ2', a: 'faqA2' },
      { q: 'faqQ3', a: 'faqA3' },
      { q: 'faqQ4', a: 'faqA4' },
      { q: 'faqQ5', a: 'faqA5' },
      { q: 'faqQ6', a: 'faqA6' },
    ],
    []
  );

  return (
    <header className={`landing-top-nav ${isMenuOpen ? 'is-menu-open' : ''}`}>
      <div className="container landing-top-nav__container">
        <Link className="landing-top-nav__brand" to="/" aria-label="SWARMIND Home">
          SWARMIND
        </Link>

        <nav className="landing-top-nav__links" aria-label="Primary">
          <Link className={`landing-top-nav__link ${isActive(pathname, '/') ? 'is-active' : ''}`} to="/">
            {t('homeNav')}
          </Link>
          <Link className={`landing-top-nav__link ${isActive(pathname, '/unified-api') ? 'is-active' : ''}`} to="/unified-api">
            {t('unifiedAPINav')}
          </Link>
          <Link className={`landing-top-nav__link ${isActive(pathname, '/gpu-rental') ? 'is-active' : ''}`} to="/gpu-rental">
            {t('gpuRentalNav')}
          </Link>
          <Link
            className={`landing-top-nav__link ${isActive(pathname, '/for-developers') || isActive(pathname, '/free-infrastructure') ? 'is-active' : ''}`}
            to="/for-developers"
          >
            {t('freeInfrastructureNav')}
          </Link>
        </nav>

        <button
          type="button"
          className="landing-top-nav__menuButton"
          aria-label={isMenuOpen ? 'Close menu' : 'Open menu'}
          aria-expanded={isMenuOpen}
          onClick={() => setIsMenuOpen(v => !v)}
        >
          <span className="landing-top-nav__menuIcon" aria-hidden="true" />
        </button>
      </div>

      {isMenuOpen && (
        <>
          <div className="landing-mobile-overlay" onClick={() => setIsMenuOpen(false)} aria-hidden="true" />
          <aside className="landing-mobile-drawer" aria-label="Menu">
            <div className="landing-mobile-drawer__header">
              <div className="landing-mobile-drawer__title">SWARMIND</div>
              <button
                type="button"
                className="landing-mobile-drawer__close"
                aria-label="Close menu"
                onClick={() => setIsMenuOpen(false)}
              >
                ×
              </button>
            </div>

            <div className="landing-mobile-drawer__section">
              <div className="landing-mobile-drawer__sectionTitle">Menu</div>
              <div className="landing-mobile-drawer__links">
                <Link className="landing-mobile-drawer__link" to="/" onClick={() => setIsMenuOpen(false)}>
                  {t('homeNav')}
                </Link>
                <Link className="landing-mobile-drawer__link" to="/unified-api" onClick={() => setIsMenuOpen(false)}>
                  {t('unifiedAPINav')}
                </Link>
                <Link className="landing-mobile-drawer__link" to="/gpu-rental" onClick={() => setIsMenuOpen(false)}>
                  {t('gpuRentalNav')}
                </Link>
                <Link className="landing-mobile-drawer__link" to="/for-developers" onClick={() => setIsMenuOpen(false)}>
                  {t('freeInfrastructureNav')}
                </Link>
              </div>
            </div>

            <div className="landing-mobile-drawer__section">
              <div className="landing-mobile-drawer__sectionTitle">{t('faqTitle')}</div>
              <div className="landing-mobile-faq">
                {faqItems.map((item, idx) => {
                  const isOpen = openFaqIndex === idx;
                  return (
                    <div key={item.q} className={`landing-mobile-faq__item ${isOpen ? 'is-open' : ''}`}>
                      <button
                        type="button"
                        className="landing-mobile-faq__q"
                        onClick={() => setOpenFaqIndex(prev => (prev === idx ? null : idx))}
                        aria-expanded={isOpen}
                      >
                        <span>{t(item.q)}</span>
                        <span className="landing-mobile-faq__chev" aria-hidden="true">
                          {isOpen ? '−' : '+'}
                        </span>
                      </button>
                      {isOpen && <div className="landing-mobile-faq__a">{t(item.a)}</div>}
                    </div>
                  );
                })}
              </div>
            </div>
          </aside>
        </>
      )}
    </header>
  );
};

